import { render, staticRenderFns } from "./ModalStudentMailAddress.vue?vue&type=template&id=60e0ac7c&scoped=true&lang=pug&"
import script from "./ModalStudentMailAddress.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentMailAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentMailAddress.vue?vue&type=style&index=0&id=60e0ac7c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0ac7c",
  null
  
)

export default component.exports